import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { RatingType } from '@empathy/survey/base';

import { SurveyEditorService } from '../../../../services/survey-editor.service';

@Component({
  selector: 'empathy-rating-settings',
  templateUrl: 'rating-settings.component.html',
  styleUrls: ['./rating-settings.component.scss', './_rating-settings-theme.component.scss']
})
export class RatingSettingsComponent implements OnInit, OnDestroy {
  surveyEditorService = inject(SurveyEditorService);

  activeQuestion$ = signal(this.surveyEditorService.surveyEditor$().activeQuestion);

  ratingType = RatingType;

  private subscription: Subscription;

  ngOnInit(): void {
    this.subscription = this.surveyEditorService.surveyEditor$().questionActivated$.subscribe(() => {
      this.activeQuestion$.set(this.surveyEditorService.surveyEditor$().activeQuestion);
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
